import { defineComponent as _defineComponent } from 'vue'
import { useSwiperElement } from '~/composables';
import CatalogProductCard from '~/domains/catalog/components/CatalogProductCard.vue';
import { getProductContent } from '~/helpers/vue';

interface Props {
  products?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedProducts',
  props: {
    products: { default: () => [] }
  },
  setup(__props: any) {



const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

const swiperEl = useSwiperElement(swiperOptions);

return { __sfc: true,swiperOptions, swiperEl, CatalogProductCard, getProductContent }
}

})